<template>
  <div class="home-wrap">
    <Header/>
    <!-- <div class="header">
      <div class="left">
        <img src="../assets/logo-1.png" alt="">
        ｜ animix广告机订单查询
      </div>
      <div class="right">
        <span @click="$router.push('/login')" style="margin-right: 16px;cursor: pointer">{{cname}}</span>
        <a-dropdown>
          <a href="#" style="color:white">
            {{accname}}
            <a-icon type="down"/>
          </a>
          <a-menu slot="overlay" @click="handleLogout">
            <a-menu-item key="/login">
              <span>退出登陆</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div> -->
    <div class="content-wrap">
      <div class="wrap">
        <div class="filter-wrap">
          <div class="filter-item">所属门店：
            <a-tree-select
              v-model="shopId"
              show-search
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择"
              allow-clear
              style="width: 210px"
            >
              <a-tree-select-node key="-1" value="" title="全部">
              </a-tree-select-node>
              <a-tree-select-node v-for="item in shopInfo" :key="item.customer.id" :title="item.customer.name" :selectable="false">
                <a-tree-select-node v-for="shopItem in item.shopList" :key="shopItem.shopId" :value="shopItem.shopId" :title="shopItem.shopName">
                </a-tree-select-node>
              </a-tree-select-node>
            </a-tree-select>
          </div>
          <!-- <div class="filter-item">设备名称：
            <a-select
              v-model="devid"
              style="width: 120px"
            >
              <a-select-option :value="-1">全部</a-select-option>
              <a-select-option v-for="item in devlist" :key="item.deviceId+'1'" :value="item.deviceId">{{item.deviceName}}</a-select-option>
            </a-select>
          </div> -->
          <div class="filter-item">订单类型：
            <a-select
              v-model="skuType"
              style="width: 210px"
            >
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option :value="1">领图</a-select-option>
              <a-select-option :value="2">打印</a-select-option>
            </a-select>
          </div>
          <div class="filter-item">支付状态：
            <a-select
              v-model="payStatus"
              style="width: 210px"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="name,key in orderStatusInfo" :key="key" :value="parseInt(key)">{{name}}</a-select-option>
            </a-select>
          </div>
          <div class="filter-item">设备：
            <a-input
              placeholder="设备名称或MAC地址"
              class="options-select"
              v-model="device"
              style="width: 240px"
              allowClear
            />
          </div>
        </div>
        <div class="filter-wrap">
          <div class="filter-item">创建时间：
            <a-range-picker
              @change="onDateChange"
              :value="time"
              :disabledDate="disabledDate"/>
          </div>
          <div class="filter-item">订单：
            <a-input
              placeholder="请输入订单ID、微信支付订单号、退款号"
              class="options-select"
              v-model="query"
              style="width: 380px"
              allowClear
            />
          </div>
          <!-- <a-form-model-item label="设备" prop="device">
            <a-popover
              v-model="visible"
              title=""
              trigger="click"
              placement="bottom"
              overlayClassName="devicePopover"
            >
              <template slot="content">
                <addDevice
                  ref="addDevice"
                  :deviceList="deviceList"
                  :defaultCreateDevices="defaultCreateDevices"
                  @checkedDeviceidArrHandle="checkedDeviceidArrHandle"
                />
              </template>
              <a-input
                placeholder=""
                class="options-select"
                v-model="form.device"
                style="width: 230px"
                readOnly
              />
            </a-popover>
          </a-form-model-item> -->
          <div class="filter-item">
            <a-button type="primary" @click="handleSearch">查询</a-button>
            <a-button style="margin-left: 12px" @click="reset">重置</a-button>
          </div>
        </div>
        <div class="table-wrap">
          <a-table
            :loading="tableloading"
            :columns="columns"
            :data-source="data"
            @change="onChange"
            :scroll="{x: 1200}"
            :pagination="{
              size: this.pageSize+'',
              current: this.current,
              total: this.total,
              showSizeChanger: true,
              showTotal: total => `共 ${total} 条`
            }"
          >
            <div slot="orderId" slot-scope="text">
              <div class="copywrap">
                <span>{{ text }}</span>
                <a-icon
                  type="copy"
                  class="copy"
                  v-clipboard:copy="text+''"
                  v-clipboard:success="clipboardSuccessHandler"
                />
              </div>
            </div>
            <div slot="transId" slot-scope="text,record">
                <div v-if="text">{{ text }}</div>
                <div v-if="record.returnId">(退款号：{{ record.returnId }})</div>
            </div>
            <div slot="payStatus" slot-scope="text">
                <span>{{ orderStatusInfo[text] }}</span>
            </div>
            <div slot="animixUserId" slot-scope="text">
              <div class="copywrap">
                <span>{{ text }}</span>
                <a-icon
                  type="copy"
                  class="copy"
                  v-clipboard:copy="text+''"
                  v-clipboard:success="clipboardSuccessHandler"
                />
              </div>
            </div>
            <div slot="macName" slot-scope="text,record">
              <div class="copywrap">
                <span>  {{ getMacName(record.deviceId) }}</span>
                <a-icon
                  type="copy"
                  class="copy"
                  v-clipboard:copy="getMacName(record.deviceId)"
                  v-clipboard:success="clipboardSuccessHandler"
                />
              </div>
            </div>
            <div slot="deviceName" slot-scope="text, record">
              <div class="copywrap">
                {{ getDeviceName(record.deviceId) }}
              </div>
            </div>
            <div slot="options" slot-scope="text, record">
              <a-button @click.stop="handleRefund(record)" v-if="record.payStatus === 102 && checkRufundTime(record)" type="link">退款</a-button>
            </div>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { querylist, querydev, getOrgInfo, orderRefund} from '@/api'
import moment from 'moment'
import Header from '@/views/header/header'
// import addDevice from './picture/components/add-device'
import { deviceListReq } from '@/api'
const columns = [
  {
    title: '订单id',
    dataIndex: 'orderId',
    scopedSlots: { customRender: "orderId" },
    fixed: 'left',
    width: 300
  },
  {
    title: '微信支付订单号',
    dataIndex: 'transId',
    fixed: 'left',
    scopedSlots: { customRender: "transId" },
    width: 300
  },
  {
    title: '订单类型',
    dataIndex: 'skuType',
    scopedSlots: { customRender: "skuType" },
    width: 120,
    customRender: (val) => {
      // if (val === 0) return '全部'
      if (val === 1) return '领图'
      if (val === 2) return ' 打印'
    }
  },
  {
    title: '支付状态',
    dataIndex: 'payStatus',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: "payStatus" },
  },
  {
    title: '价格',
    dataIndex: 'realWorth',
    width: 70
  },
  {
    title: '用户id',
    dataIndex: 'animixUserId',
    sorter: true,
    scopedSlots: { customRender: "animixUserId" },
    width: 200
  },
  {
    title: '设备名称',
    dataIndex: 'deviceName',
    scopedSlots: { customRender: "deviceName" },
    width: 200
  },
  {
    title: '所属门店',
    dataIndex: 'shopName',
    width: 200
  },
  {
    title: '设备MAC',
    dataIndex: 'macName',
    scopedSlots: { customRender: "macName" },
    width: 170
  },
  {
    title: '最后更新时间',
    dataIndex: 'updateTime',
    width: 200
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    defaultSortOrder: 'descend',
    sorter: true,
    width: 200
  },
  {
    title: '操作',
    align: 'center',
    scopedSlots: { customRender: "options" },
    fixed: 'right',
    width: 200
  }
];

export default {
  name: 'home',
  components: {
    Header,
    // addDevice
  },
  async created () {
    // const userinfo = localStorage.getItem('userinfo')
    // if (userinfo) {
    //   this.userinfo = JSON.parse(userinfo)
    // } else {
    //   this.$router.push('/login')
    // }
    this.cname = this.getCname()
    this.accname = this.getAccname()
    await this.getDevList()
    await this.deviceListReqHandle()
    this.getList()
    this.getShopInfo()
  },
  data () {
    return {
      form: {
        device: '请选择...',
      },
      query: '',
      device: '',
      shopId: '',
      visible: false,
      deviceList: [],
      checkedDeviceidArr: [],
      defaultCreateDevices: [],
      userinfo: '',
      accname: '',
      tablekey: 1,
      // devid: -1,
      skuType: 0,
      payStatus: '',
      time: [moment().subtract(6, 'days'), moment()],
      columns,
      data: [],
      cname: '',
      current: 1,
      pageSize: 10,
      total: 0,
      columnsKey: 'createTime',
      order: 'descend',
      devlist: [],
      tableloading: false,
      shopInfo: [],
      orderStatusInfo: {
        100: '未支付',
        101: '支付中',
        102: '已支付',
        103: '已取消',
        104: '待退款',
        105: '退款中',
        106: '已退款'
      },
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => {
          return '共 ' + total + ' 条记录'
        }
      },
    }
  },
  watch: {
    checkedDeviceidArr (newVaule) {
      // console.log(newVaule);
      if (newVaule.length === 0) {
        this.form.device = ''
      } else if (newVaule.length === 1) {
        this.form.device = "已选择" + newVaule[0].deviceName
      } else {
        this.form.device = "已选择" + newVaule[0].deviceName + "等" + newVaule.length + "个设备"
      }
    }
  },
  methods: {
    checkRufundTime (row) {
      return moment(row.updateTime).add(7, 'days') > moment()
    },
    handleRefund (row) {
      this.$confirm({
        title: '退款操作确认',
        width: 400,
        content: <div><span style="color:#F04134;">此订单的费用原路退回给用户</span>，可能对您造成经济损失，是否仍要退款?</div>,
        okText: '确认',
        cancelText: '取消',
        onOk: ()=>{
          orderRefund({orderId: row.orderId, createTime: row.createTime}).then(res => {
            this.$message.success('操作成功')
            this.getList(1)
          }).catch(err => {
            console.log((err && err.message) || '操作失败')
          })
        }
      })
    },
    getShopInfo() {
      getOrgInfo().then(res => {
        this.shopInfo = JSON.parse(JSON.stringify(res))
      })
    },
    // 获取设备信息
    async deviceListReqHandle () {
      let res = await deviceListReq()
      // console.log(res);
      this.handleDevice(res)
      console.log(this.deviceList);
      this.setDefaultCreateDevices()
    },
    handleDevice(res) {
      let arr = []
      for(let key in res) {
        let obj = {}
        obj.shopName = key
        obj.shopId = res[key][0].shopId
        obj.devices = res[key]
        arr.push(obj)
      }
      // console.log(arr);
      this.deviceList = arr
    },
    setDefaultCreateDevices () {
      let checkedDeviceidArr = []
      this.defaultCreateDevices = []
      this.defaultCreateDevices.push('0')
      this.deviceList.map(item => {
        this.defaultCreateDevices.push(item.shopId)
        item.devices.map(it => {
          this.defaultCreateDevices.push(it.deviceId)
          checkedDeviceidArr.push(it)
        })
      })

      this.checkedDeviceidArr = checkedDeviceidArr
      console.log('this.checkedDeviceidArr', this.checkedDeviceidArr);
      // this.getList()
    },
    checkedDeviceidArrHandle (arr) {
      this.checkedDeviceidArr = arr
    },
    moment,
    getDevList () {
      querydev().then(res => {
        this.devlist = res
      })
    },
    handleSearch () {
      this.getList()
    },
    getAccname () {
      return localStorage.getItem('usename')
    },
    getCname () {
      try {
        const cid = localStorage.getItem('customerCode')
        const clist = JSON.parse(localStorage.getItem('cusList'))
        if (Array.isArray(clist)) {
          return clist.filter(i => i.cid == cid)[0].cname
        } else {
          return ''
        }
      } catch (e) {
        console.log(e)
      }
    },
    clipboardSuccessHandler () {
      this.$message.success('复制成功！')
    },
    onChange ({ current, pageSize }, filters, { columnKey, order }) {
      this.getList(current, pageSize, columnKey, order)
      // order "descend"  "ascend" undefined
    },
    disabledDate (current) {
      return (
        current > moment()
      );
    },
    clearAllCookie () {
      // eslint-disable-next-line
      const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (let i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
      }
    },
    async handleLogout () {
      localStorage.removeItem('usename')
      localStorage.removeItem('cusList')
      localStorage.removeItem('customerCode')
      this.clearAllCookie()
      this.$router.push('/login')
    },
    onDateChange (date, dateString) {
      const datediff = date[1].diff(date[0], 'days')
      console.log(datediff)
      if (datediff < 90) {
        this.time = date
      } else {
        this.$message.warn('创建时间间隔最长90天')
      }
      console.log(date, dateString);
    },
    getList (current = 1, pageSize = this.pageSize, columnKey = this.columnsKey, order = this.order) {
      this.tableloading = true
      this.current = current
      this.pageSize = pageSize
      this.columnsKey = columnKey
      this.order = order
      querylist({
        shopId: this.shopId || undefined,
        query: this.query || undefined,
        device: this.device || undefined,
        // deviceId: this.checkedDeviceidArr.map(item => item.deviceId),
        // deviceId: this.devid < 0 ? undefined : this.devid,
        payStatus: this.payStatus ? this.payStatus : undefined,
        startTime: this.time[0].format('YYYY-MM-DD'),
        endTime: this.time[1].format('YYYY-MM-DD'),
        skuType: this.skuType,
        columnName: columnKey,
        sort: order,
        pageNum: current,
        pageSize: pageSize
      }).then(res => {
        this.data = res.list || []
        this.total = res.total
      }).finally(() => {
        this.tableloading = false
      })
    },
    getDeviceName (deviceid) {
      const item = this.devlist.filter(i => i.deviceId === deviceid)[0]
      if (item) {
        return item.deviceName
      }
      return ''
    },
    getMacName (deviceid) {
      const item = this.devlist.filter(i => i.deviceId === deviceid)[0]
      if (item) {
        return item.deviceMac
      }
      return ''
    },
    reset () {
      if (this.$refs.addDevice) {
        this.$refs.addDevice.resetHandle()
      }
      // this.devid = -1
      this.time = [moment().subtract(6, 'days'), moment()]
      this.payStatus = ''
      this.skuType = 0
      this.device = ''
      this.query = ''
      setTimeout(() =>{
        this.getList();
      }, 300)
      // this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.home-wrap{
  background-color: white;
  width: 100%;
  height: 100vh;
  .header{
    width: 100%;
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding-left: 20px;
    height: 60px;
    line-height: 60px;
    background-color: #414042;
    color: white;
    font-size: 18px;
    .right{
      margin-right: 20px;
    }
  }
  .content-wrap{
    padding: 20px;
    background-color: #eff0f1;
    height: calc(100vh - 60px);
    .wrap{
      background-color: white;
      padding: 20px;
      .filter-wrap{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 8px;
        .filter-item{
          //flex: 1;
          margin-right: 30px;
          margin-bottom: 8px;
          &:last-child{
            margin-right: 0;
          }
        }

      }
    }
  }
  .btn-wrap{
    margin-top: 10px;
    display: flex;
    align-content: center;
    justify-content: flex-start;
  }
  .table-wrap{
    margin-top: 16px;
    /deep/.copywrap{
      .copy{
        margin-left: 8px;
        display: none;
        cursor: pointer;
      }
      &:hover{
       .copy{
         display: inline-block;
       }
      }
    }
  }
  .ant-form-item {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 8px;
    margin-right: 30px;
    /deep/.ant-form-item-label {
      display: inline-block;
      vertical-align: top;
    }
    /deep/.ant-form-item-control-wrapper {
      display: inline-block;
      vertical-align: top;
    }
  }

}

</style>
